import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAutocomplete,_vm._b({attrs:{"dense":"","outlined":"","label":_vm.$t('Sort amount'),"items":_vm.sortTotalItems,"hide-details":"auto","clearable":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t(item.text)))])]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-capitalize"},[_vm._v(_vm._s(_vm.$t(item.text)))])]}}]),model:{value:(_vm.sortTotal),callback:function ($$v) {_vm.sortTotal=$$v},expression:"sortTotal"}},'v-autocomplete',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }